const messagesByChannelsConfig = {
  name: 'messages_by_channel',
  title: 'Message Counts',
  metric: 'messages_by_channel',
  helpText: 'The <i>Message Counts</i> graph displays the total number of messages for each channel during the specified date range.',
  maxTickLabelCount: 8,
  graphParams: {
    autoColorAssignKey: 'messages_by_channel',
  },
};

export default messagesByChannelsConfig;
